export const userConstants = {
    REGISTER_CHANGEPASS_REQUEST: 'REGISTER_CHANGEPASS_REQUEST',
    REGISTER_CHANGEPASS_SUCCESS: 'REGISTER_CHANGEPASS_SUCCESS',
    REGISTER_CHANGEPASS_FAILURE: 'REGISTER_CHANGEPASS_FAILURE',

    RECOVER_PASSWORD_REQUEST: 'RECOVER_PASSWORD_REQUEST',
    RECOVER_PASSWORD_SUCCESS: 'RECOVER_PASSWORD_SUCCESS',
    RECOVER_PASSWORD_FAILURE: 'RECOVER_PASSWORD_FAILURE',
}